//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "MarketingCampaignCriteria",
  props: {
    name: {
      type: String,
      required: true
    }
  }
});